export const priceKeys = [
  'price_high',
  'price_mid',
  'price_low',
];

export default {
  priceKeys,
};
